import { Theme, styled } from '@material-ui/core';
import { FormControl, ListItem, LocalLoading, Paragraph } from 'src/modules/shared/components';

export const ListItemWrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  '&.with-preference-selection': {
    paddingLeft: theme.spacing(3),
  },
  '&:nth-child(odd) .listItem': {
    width: '100%',
    background: theme.palette.background.default,
  },
}));

export const DifferentiationsListWrapper = styled('div')<Theme>(({ theme }) => ({
  margin: theme.spacing(2, 0),
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'hidden',
  gap: theme.spacing(2),
}));

export const ActiveIndicator = styled('span')<Theme>(({ theme }) => ({
  display: 'inline-block',
  marginLeft: theme.spacing(0.5),
  color: theme.palette.grey['600'],
  fontStyle: 'italic',
}));

export const DifferentiationIndicatorWrapper = styled('div')<Theme>(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey['A100'],
  display: 'inline-block',
  position: 'relative',
  zIndex: 20,
}));

export const DifferentiationLabel = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  marginRight: theme.spacing(1),
}));

export const DifferentiationTitleWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  postion: 'relative',
  height: 'auto',
  '& > span': {
    marginBottom: theme.spacing(1),
  },
}));

export const TrajectoryTitle = styled('span')<Theme>(({ theme }) => ({
  marginRight: theme.spacing(1),
  height: '2.2rem',
}));

export const TrajectoryOwner = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  height: '2.2rem',
  margin: '0 2rem 2rem 0',
}));

export const EditViewModeWrapper = styled('span')({
  position: 'relative',
});

export const ListWrapper = styled('div')({
  height: 'calc(100vh - 28rem)',
  overflowY: 'auto',
});

export const StyledListItem = styled(ListItem)<Theme>(({ theme }) => ({
  padding: theme.spacing(0.5, 2),
}));

export const OtherDifferentiationIndicator = styled('span')<Theme>(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.primary.main,
}));

export const StyledForm = styled('form')<Theme>(({ theme }) => ({
  '& > *': {
    marginTop: theme.spacing(3),
  },
}));

export const StyledFormGroup = styled(FormControl)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const FieldDisablerWrapper = styled('div')({
  position: 'relative',
});

export const FieldDisabler = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: theme.palette.common.white,
  opacity: 0.75,
}));

export const StyledLocalLoading = styled(LocalLoading)<Theme>(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(4),
}));

export const StyledIntro = styled(Paragraph)<Theme>(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const DifferentiationsOverviewWrapper = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const DifferentiationsFormWrapper = styled('div')<Theme>(({ theme }) => ({
  height: `100%`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const DifferentiationsFormContent = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2),
  '& .MuiSvgIcon-root': {
    color: '#ffffff',
  },
}));

export const DeleteWrapper = styled('div')<Theme>(({ theme }) => ({
  height: `100%`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));
